/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RefreshMcpApprovalEvidenceSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type RefreshMcpApprovalEvidenceRequest = {
  /**
   * The approval request ID.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type RefreshMcpApprovalEvidenceSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RefreshMcpApprovalEvidenceSecurity$outboundSchema: z.ZodMiniType<
  RefreshMcpApprovalEvidenceSecurity$Outbound,
  RefreshMcpApprovalEvidenceSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function refreshMcpApprovalEvidenceSecurityToJSON(
  refreshMcpApprovalEvidenceSecurity: RefreshMcpApprovalEvidenceSecurity,
): string {
  return JSON.stringify(
    RefreshMcpApprovalEvidenceSecurity$outboundSchema.parse(
      refreshMcpApprovalEvidenceSecurity,
    ),
  );
}

/** @internal */
export type RefreshMcpApprovalEvidenceRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const RefreshMcpApprovalEvidenceRequest$outboundSchema: z.ZodMiniType<
  RefreshMcpApprovalEvidenceRequest$Outbound,
  RefreshMcpApprovalEvidenceRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function refreshMcpApprovalEvidenceRequestToJSON(
  refreshMcpApprovalEvidenceRequest: RefreshMcpApprovalEvidenceRequest,
): string {
  return JSON.stringify(
    RefreshMcpApprovalEvidenceRequest$outboundSchema.parse(
      refreshMcpApprovalEvidenceRequest,
    ),
  );
}
